import { useCallback, useEffect, useState } from 'react';
import { Device, DeviceInfo } from '@capacitor/device';

export async function getDevice() {
	const device = await Device.getInfo();
	return device;
}

export function useDevice() {
	const [device, setDevice] = useState<DeviceInfo | null>(null);

	const fetchDevice = useCallback(async () => {
		const dev = await getDevice();
		setDevice(dev);
	}, [setDevice]);

	useEffect(() => {
		fetchDevice();
	}, [fetchDevice]);
	return device;
}
